interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schemaJson?: object;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schemaJson }: SEOHeadProps) {
  const fullTitle = title.includes('九色导航') ? title : `${title} - 九色导航`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={`https://www.jiusenavigation.com${canonicalUrl}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={`https://www.jiusenavigation.com${canonicalUrl}`} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:site_name" content="九色导航" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {schemaJson && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaJson) }}
        />
      )}
    </>
  );
}